const labelMappings = {
  "es-AR": {
    Panty: "Vedetina",
    Cachetero: "Culotte",
  },
  "es-UY": {
    Panty: "Vedetina",
    Cachetero: "Culotte",
  },
  "es-CO": {
    "Extra Larga": "Extra Larga (32 Cm)",
    Normal: (nameFilter) => {
      if (nameFilter === "tipoDeToalla") {
        return "Normal (24 Cm)";
      } else if (nameFilter === "flujo") {
        return "Abundante";
      } else {
        return "Normal";
      }
    },
    Larga: "Larga (28 Cm)",
    Panty: nameFilter => (nameFilter === "ropaInterior" ? "Normal" : "Panty"),
    Activa: "Día",
    Dormir: "Noche",
    Digital: "Sin aplicador",
  },
  "es-CL": {
    Panty: "Bikini",
    Cachetero: "Pantaletas",
    Tanga: "Colaless",
    Sensible: "Suave",
    Activa: "Día",
    Dormir: "Noche",
    Normal: (nameFilter) => {
      if (nameFilter === "tipoDePiel") {
        return "Malla";
      } else if (nameFilter === "flujo") {
        return "Abundante";
      } else {
        return "Normal";
      }
    },
  },
  "es-PY": {
    Panty: "Bikini",
    Cachetero: "Culotte",
  },
}

export const handleName = (label, nameFilter) => {

  switch (label) {
    case "Liviano":
      return "Regular"
    case "Normal":
      if (nameFilter === "flujo") {
        return "Abundante"
      }
      return label
    case "Fuerte":
      return "Súper Abundante"
  }
  
  const localeMappings = labelMappings[process.env.LOCALE];

  if (!localeMappings) {
    return label;
  }
  const mappedLabel = localeMappings[label];

  if (typeof mappedLabel === "function") {
    return nameFilter ? mappedLabel(nameFilter) : mappedLabel();
  } else if (mappedLabel !== undefined) {
    return mappedLabel;
  }

  return label;
}